import { cn } from "@/lib/cn";
import { VideoCardSkeleton } from "./VideoCard";

/** 1 → 6 columns; five across at a typical laptop width, like beeg. */
export const gridClass =
  "grid grid-cols-1 gap-x-3.5 gap-y-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 wide:grid-cols-5 ultra:grid-cols-6";

/** Live streams on the home page, whose filters are in the left menu: seven across on a laptop and up. */
export const streamGridClass = "grid grid-cols-1 gap-x-3 gap-y-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 wide:grid-cols-7";

export function VideoGrid({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn(gridClass, className)}>{children}</div>;
}

export function VideoGridSkeleton({ count = 15 }: { count?: number }) {
  return (
    <VideoGrid>
      {Array.from({ length: count }, (_, i) => (
        <VideoCardSkeleton key={i} />
      ))}
    </VideoGrid>
  );
}
